function NotFound(){
    return(
        <section style={{minHeight: '56vh'}}>
            <h2>Ops!</h2>
            <p>O conteúdo que você procura não foi encontrado!</p>
        </section>
    )
}

export default NotFound
